<template>
    <b-card-group deck>
      <b-card no-body class="shadow rounded" v-if="participant.id">
        <div class="card-body p-3">
          <div class="card-title">
              <h5><strong class="text-danger">{{ participant.name }}</strong>, hier zijn jouw getrokken lootjes</h5>
          </div>
          <div class="d-flex flex-column justify-content-stretch">
            <b-card v-for="(draw, index) in drawsSpecial" :key="index" class="draw-card special shadow">
              <b-card-title class="d-flex justify-content-between align-items-center mb-4">
                <span>
                  <font-awesome-icon icon="gift" />
                  Groot cadeau
                </span>
                <b-card-sub-title class="font-weight-bold mt-0">surprise + gedicht</b-card-sub-title>
              </b-card-title>
              <b-card-text class="text-center border-top p-5">
                <a class="pointer d-flex justify-content-between align-items-center" v-on:click="getWishlist(draw.participant.id)" v-scroll-to="{ el: '#wishlist-' + draw.participant.id, offset: -100}">
                  <font-awesome-icon icon="hand-point-right" class="text-muted" />
                  {{ draw.participant.name }}
                  <font-awesome-icon icon="hand-point-left" class="text-muted" />
                </a>
              </b-card-text>
            </b-card>
          </div>

          <div class="d-flex flex-column flex-md-row justify-content-stretch">
            <b-card v-for="(draw, index) in drawsNormal" :key="index" class="draw-card shadow">
              <b-card-title class="d-flex justify-content-between align-items-center mb-4">
                <span>
                  <font-awesome-icon icon="candy-cane" />
                  Klein cadeau
                </span>
              </b-card-title>
              <b-card-text class="text-center border-top py-5 px-5 px-md-0">
                <a class="pointer d-flex justify-content-between align-items-center" v-on:click="getWishlist(draw.participant.id)" v-scroll-to="{ el: '#wishlist-' + draw.participant.id, offset: -100}">
                  <font-awesome-icon icon="hand-point-right" class="text-muted" />
                  {{ draw.participant.name }}
                  <font-awesome-icon icon="hand-point-left" class="text-muted" />
                </a>
              </b-card-text>
            </b-card>
          </div>
        </div>
      </b-card>

      <b-card no-body class="shadow rounded" v-if="participant.id">
        <b-card-body class="px-0 py-3">
          <div class="card-title">
            <h5 class="px-3">
              <strong class="text-danger">{{ participant.name }}</strong>, vul je wensen in:
            </h5>
          </div>
          <b-card-body class="px-0">
              <b-list-group class="list-group-flush">
                  <b-list-group-item v-for="(item, index) in participant.wishlist.items" :key="index" class="d-flex w-100 justify-content-between align-items-stretch shadow">
                    <div class="d-flex w-75 align-items-stretch">
                      <font-awesome-icon icon="gift" />
                      <vue-markdown class="pl-3 w-100 mr-2" :anchorAttributes="{ target: '_blank' }" v-if="edit != item.id" :source="item.description"></vue-markdown>
                      <b-textarea v-model="item.description" class="ml-3 mr-2 w-100" v-else></b-textarea>
                    </div>
                    <b-button-group>
                      <b-button variant="outline-danger" v-on:click="toggleEdit(participant.wishlist.id, item)"><font-awesome-icon icon="edit" /></b-button>
                      <b-button variant="outline-danger" v-on:click="confirmDelete(item.id)"><font-awesome-icon icon="trash" /></b-button>
                    </b-button-group>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex w-100 justify-content-between align-items-stretch border-top shadow">
                    <div class="d-flex w-100 align-items-stretch">
                      <font-awesome-icon icon="gift" />
                      <b-textarea v-model="wishlistItem" placeholder="Voer hier je wens in" class="ml-3 mr-5 w-100"></b-textarea>
                    </div>
                    <b-button-group>
                      <b-button variant="outline-danger" v-on:click="addItem(participant.wishlist.id)"><font-awesome-icon icon="plus-circle" /></b-button>
                    </b-button-group>
                  </b-list-group-item>
              </b-list-group>
          </b-card-body>
          <b v-if="!participant.wishlist.items.length" class="text-danger">er is geen wenslijst!</b>
        </b-card-body>
      </b-card>
      <code-input-component v-if="!participant.id"></code-input-component>
    </b-card-group>
</template>

<script>
import axios from 'axios'
import { mapState, mapActions } from 'vuex'
import { apiUrl } from '@/config'
import CodeInputComponent from '@/components/CodeInputComponent'

export default {
  computed: mapState({
    code: state => state.participants.code,
    event: state => state.event,
    participant: state => state.participants.participant,
    drawsSpecial: state => state.participants.participant.draws.filter(d => d.special),
    drawsNormal: state => state.participants.participant.draws.filter(d => !d.special)
  }),
  data: () => {
      return {
        wishlistItem: null,
        edit: null,
      }
  },
  methods: {
    getParticipant() {
      this.$store.dispatch('participants/getParticipant', this.$route.params.event);
    },
    getWishlist(participant) {
      this.$store.dispatch('wishlists/getWishlist', participant);
    },
    toggleEdit(wishlist, item) {
      if (this.edit === item.id) {
        this.edit = null;
        return axios.put(`${apiUrl}/api/wishlist/item/${item.id}`, {wishlist, 'description': item.description})
          .then(response => { this.getParticipant(); })
          .catch(e => { console.log(e) });
      } else {
        this.edit = item.id;
      }
    },
    confirmDelete(id) {
      if (confirm("weet je het zeker?")) {
        return axios.delete(`${apiUrl}/api/wishlist/item/${id}`)
          .then(response => { this.getParticipant(); })
          .catch(e => { console.log(e) });
      }
    },
    addItem(wishlist) {
      return axios.post(`${apiUrl}/api/wishlist/item`, {wishlist, 'description': this.wishlistItem})
        .then(response => { 
          this.getParticipant();
          this.wishlistItem = null;
        })
        .catch(e => { console.log(e) });
    },
  },
  filters: {
    special(value) {
      return value.special;
    }
  },
  watch: {
    code (newCode, oldCode) {
      this.getParticipant();
    }
  },
  created() {
    this.getParticipant();
  },
  components: {
    CodeInputComponent,
  }
}
</script>

<style lang="scss" scoped>


.draw-card {
  width: 100% !important;
  margin: 1em 0 !important;

  &.special {
    font-size: 1.5em;
    width: 100% !important;
  }
}

.pointer {
  cursor: pointer;
}

@media (min-width: 768px) {
  .draw-card {
    width: 50% !important;

    &.special {
      width: 100% !important;
    }
  }
}
</style>
